import "./InitializingView.css";
import Spinner from "./Spinner";

const InitializingView = () => {
  return (
    <div className="initializing-root">
      <div className="initializing-bg" aria-hidden="true">
        <span className="blob blob-1" />
        <span className="blob blob-2" />
        <span className="blob blob-3" />
        <span className="blob blob-4" />
        <span className="grain" />
      </div>

      <div className="initializing-content">
        <Spinner label="Loading..." />
      </div>
    </div>
  );
};

export default InitializingView;
